import { isCustomizedType, reduce } from "et3-type-guards";

import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { TUserPendingReports } from "../../Types";
import { post } from "../axios-post";

export const apiCallGetPendingReportsByUserID = async ({
  userID
}: {
  userID: number;
}): Promise<{
  data: TUserPendingReports;
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<TUserPendingReports>(
    `reports/getPendingReportsByUserID`,
    {
      userID
    }
  );

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: {
        userReports: data.userReports,
        pool: data.pool
      },
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: {
        userReports: {},
        pool: ""
      },
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: {
        userReports: {},
        pool: ""
      },
      status: "ERROR",
      code: "ERROR"
    };
  }
};
